// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"component-layout"},"nodeName":"g","children":[{"attributes":{"id":"fill1","fill":"transparent","d":"M21 3L16.5 3L12 3L12 21H16.5H21L21 3Z"},"nodeName":"path","children":[]},{"attributes":{"id":"fill2","fill":"transparent","d":"M12 3L7.5 3L3 3L3 21H7.5H12L12 3Z"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M12 3H3L3 21H12M12 3H21V21H12M12 3V12M12 21V12M12 12H3","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-component-layout')
export default class ComponentLayoutIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'component-layout',
    }
  }
}
